import Vue from 'vue'
import ChainingHelper from '../../../chaining/vue/classes/ChainingHelper'
import { allergyCategoryEnum } from '../../../dPpatients/vue/Enum/allergyCategoryEnum'
import AllergyHelper from '../classes/AllergyHelper'

export default {
    saveCodingInformation: (state, codingInformation) => {
        state.codingInformation = codingInformation
    },
    emptyAllergiesStoreByKey: (state, storeKey) => {
        Vue.set(state.allergiesDataByKey, storeKey, {
            allergiesPatient: [],
            aversionsPatient: [],
            intolerancesPatient: [],
            allergiesImmunePatient: [],
            reactionsPatient: [],
            allergiesAversionLinkedPatient: [],
            allergiesIntoleranceLinkedPatient: [],
            allergiesFoodRefAllergenPatient: [],
        })
    },
}
